const login = () => import(/* webpackPrefetch: true */ '@/views/public/index.vue')
const routes = [
  {
    path: "/login",
    name: "Admin Login",
    component: login,
    meta: {
      title: "Admin Login"
    }
  },
]
export default routes.map(route => {
  const meta = {
    all: false, 
    public: true,
    onlyLoggedOut: true,
    title: route.meta.title
  }
  return { ...route, meta }
})